import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { isEqual, isUndefined } from 'lodash';
import { Loader } from '@components/common';
import ReportFiltersForm from '@contexts/reportFilters';
import { thunks } from '@redux/reports';
import { bindActionCreators } from 'redux';
import { reportTypes } from '@config';
import InvoiceHistoryReport from './components/invoiceHistoryReport';
import PaymentHistoryReport from './components/paymentHistoryReport';
import TransactionHistoryReport from './components/transactionHistoryReport';
import OfficerOverviewReport from './components/officerOverviewReport';
import LocationOverviewReport from './components/locationOverviewReport';
import ClientOverviewReport from './components/clientOverviewReport';
import Filter from './components/filter';

class HistoryReports extends Component {
	shouldComponentUpdate = ({
		loading,
		reportType,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.loading, loading)
			|| !isEqual(lastProps.reportType, reportType)
		);
	};

	exportReport = (type, form, reportType) => () => {
		const { applyFilterExportReportData } = this.props;
		applyFilterExportReportData(type, form);

		ReactGA.event({
			category : 'Reports',
			action   : `Downloaded ${reportTypes[reportType].label} ${type.toUpperCase()} Report`,
		});
	}

	render() {
		const { loading, reportType = 0 } = this.props;

		return (
			<ReportFiltersForm.Provider>
				<Grid className="margin-0 padding-0 width-100-p">
					<Col
						md={3}
						sm={12}
						xs={12}
						className="bg-white padding-30 report-filter-border hidden-print"
					>
						<Filter />
					</Col>
					<Col
						md={9}
						sm={12}
						xs={12}
						className="padding-0"
					>
						<div className="reports-div padding-top-10">
							<Choose>
								<When condition={reportType === 0}>
									<InvoiceHistoryReport />
								</When>
								<When condition={reportType === 1}>
									<PaymentHistoryReport />
								</When>
								<When condition={reportType === 2}>
									<TransactionHistoryReport />
								</When>
								<When condition={reportType === 3}>
									<OfficerOverviewReport />
								</When>
								<When condition={reportType === 4}>
									<ClientOverviewReport />
								</When>
								<When condition={reportType === 5}>
									<LocationOverviewReport />
								</When>
								<Otherwise>
									<div className="panel-container margin-top-30">
										<div className="empty-panel">
											<h4>Please select a report type</h4>
										</div>
									</div>
								</Otherwise>
							</Choose>
							<If condition={!isUndefined(reportType)}>
								<ReportFiltersForm.Consumer>
									{ ({ form }) => (
										<div className="report-icons-container hidden-print">
											<i
												onClick={this.exportReport('pdf', form, reportType)}
												className="rkf rkf-pdf font-size-20 color-gray-oxford padding-right-10 cursor-pointer"
												onKeyPress={null}
												role="button"
												tabIndex={-2}
												alt="Download Report as PDF"
											/>
											<i
												onClick={this.exportReport('csv', form, reportType)}
												className="rkf rkf-csv font-size-20 color-gray-oxford padding-right-10 cursor-pointer "
												onKeyPress={null}
												role="button"
												tabIndex={-1}
												alt="Download Report as CSV"
											/>
											<i
												onClick={() => window.print()}
												className="rkfm rkfm-printer print-icon font-size-20 color-gray-oxford cursor-pointer"
												onKeyPress={null}
												role="button"
												tabIndex={0}
												alt="Print Report"
											/>
										</div>
									)}
								</ReportFiltersForm.Consumer>
							</If>
						</div>
					</Col>
					<Loader active={loading.report} />
				</Grid>
			</ReportFiltersForm.Provider>
		);
	}
}

const mapStateToProps = ({
	reports : {
		loading,
		filterForm,
		reportType,
	},
}) => ({
	loading,
	filterForm,
	reportType,
});

const mapDispatchToProps = (dispatch) => ({
	applyFilterExportReportData : bindActionCreators(thunks, dispatch).applyFilterExportReportData,
});

HistoryReports.propTypes = {
	applyFilterExportReportData : PropTypes.func.isRequired,
	loading                     : PropTypes.object.isRequired,
	reportType                  : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
};

HistoryReports.defaultProps = {
	reportType : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryReports);
